const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrskolaBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "forskola",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270.2 338.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "border",
    d: "M1,79.22c.59-1,67.73-62.07,67.73-62.07L134.5.26l66.95,19L266,81.89l-.89,177.33s5.44,8.35,4.74,11.26c-1.48,6.22-11.29,7.1-12.18,11.27s5.07,8.2,1.81,15.95c-1.55,3.68-16.52,5.21-17.3,7.2s-4.33,11.27-1.66,13.15,3.84,10.48-2.22,10.78-12.55-4.18-16-2.83-9.41,4.93-15.6,2.84S194,327.94,186,330.9s-37.62,11.26-48.87,5.33-19.41-8.44-38.67-14.62S75.34,307.8,78,295.5s12-29.73,12-29.73L.32,265.22C.62,264.05,1,79.22,1,79.22Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrskolaBorder);
export default __webpack_public_path__ + "static/media/förskola-border.7acdb715ff88cb1f79f5ea3078ae9b75.svg";
export { ForwardRef as ReactComponent };